import React from 'react'
import Link from './Link'
import Image from './Image'

import Placeholder from '../../assets/images/placeholder-logo.svg'
import Headline from './Headline'
import FadeInBottomEffect from '../effect/FadeInBottomEffect'

import * as moment from 'moment'

import { useTranslation } from 'react-i18next'

const ArticleStackedTeaser = ({ item, lang, className, hideDate = false }) => {
  const { t } = useTranslation()

  let fullSlug = item.full_slug ? item.full_slug : item.node?.full_slug
  let name = item.name ? item.name : item.node?.name
  let content
  if (item.content) {
    content = JSON.parse(item.content)
  } else if (item.node?.content) {
    content = JSON.parse(item.node?.content)
  }

  let date =
    item.field_date_string?.length > 0
      ? item.field_date_string
      : item.node?.field_date_string?.length > 0
      ? item.node?.field_date_string
      : content?.date?.length > 0
      ? content.date
      : ''
  moment.locale(lang)
  if (date?.length > 0) {
    date = moment(date).format('MMM YYYY')
  }

  return (
    <FadeInBottomEffect
      className={`stacked-teaser-item article-stacked-teaser-item ${
        className ? className : ''
      }`}
      tagName="section"
    >
      <article>
        <Link link={`/${fullSlug}`}>
          <div
            className={`teaser-item-image${
              content?.header_image ? '' : '-placeholder'
            }`}
          >
            <Image
              image={content?.header_image ? content.header_image : Placeholder}
              alt={name}
              title={name}
              imageWidth="360"
              imageHeight="203"
            />
          </div>

          <div className="teaser-item-content">
            <div>
              <div className="teaser-item-kicker-row">
                {name?.length > 0 && <p className="h3-kicker">{name}</p>}
                {/* {date?.length > 0 && !hideDate && (
                  <span className="teaser-item-date">{date}</span>
                )} */}
              </div>
              {content?.headline?.length > 0 && (
                <h3 className="h3-headline">{content.headline}</h3>
              )}
            </div>

            {/* <Headline
              tagName="h3"
              headline_level="h3"
              kicker={`${date ? date + ' – ' : ''}${name}`}
              headline={content.headline}
            /> */}
            {content?.teaser?.length > 0 && (
              <p className="teaser-item-text">{content.teaser}</p>
            )}
          </div>
        </Link>
      </article>
    </FadeInBottomEffect>
  )
}

export default ArticleStackedTeaser
